export function convertBase64ToBlob(base64String: string, contentType: string): Blob {
	const bstr = window.atob(base64String);
	let n = bstr.length;
	const u8arr = new Uint8Array(n);

	while (n--) {
		u8arr[n] = bstr.charCodeAt(n);
	}

	return new Blob([u8arr], { type: contentType });
}
